export { default as useCacheProducts } from './useCacheProducts';
